<template>
    <div>
        <el-input ref="iconInputRef" v-model="value" clearable placeholder="请选择图标" @focus="iconBox" :size="size">
            <template #prepend>
                <ui-icon :type="value" size="20" />
            </template>
        </el-input>
        <el-dialog v-model="innerVisible" width="70%" title="Icon" append-to-body>
            <icon-list @iconListClick="onIconListClick" />
        </el-dialog>
    </div>
</template>

<script>
    import { getCurrentInstance, defineComponent, ref, inject, watch } from 'vue'
    import IconList from '@/components/ui-icon/list'
    export default defineComponent({
        components: {
            IconList
        },
        props: {
            attr: {
                type: [Array, Object],
                default: () => {}
            },
            modelValue: {
                type: [Number, String, Array, Object],
                default: ''
            }
        },
        setup(props, context) {
            const innerVisible = ref(false)
            const iconInputRef = ref()
            const value = ref(props.modelValue)
            const size = ref(props.size)
            let isaaa = true
            const iconBox = () => {
                if (isaaa) {
                    innerVisible.value = true
                }
            }
            const onIconListClick = (e) => {
                isaaa = false
                value.value = e
                context.emit('update:modelValue', e)
                iconInputRef.value.blur()
                innerVisible.value = false
                setTimeout(() => {
                    isaaa = true
                }, 1000)
            }
            return {
                value,
                innerVisible,
                onIconListClick,
                iconBox,
                iconInputRef,
                size
            }
        }
    })
</script>

<style scoped>

</style>
